export const summaryPageTopMenu = {
	intro: { id: 'intro', text: 'Intro', path: '#intro', icon: 'Vrpano', subMenu: null },
	bootstrap: {
		id: 'bootstrap',
		text: 'Bootstrap Components',
		path: '#bootstrap',
		icon: 'BootstrapFill',
		subMenu: null,
	},
	storybook: {
		id: 'storybook',
		text: 'Storybook',
		path: '#storybook',
		icon: 'CustomStorybook',
		subMenu: null,
	},
	formik: {
		id: 'formik',
		text: 'Formik',
		path: '#formik',
		icon: 'CheckBox',
		subMenu: null,
	},
	apex: {
		id: 'apex',
		text: 'Apex Charts',
		path: '#apex',
		icon: 'AreaChart',
		subMenu: null,
	},
};

export const dashboardPagesMenu = {
	dashboard: {
		id: 'dashboard',
		text: 'Dashboard',
		path: '/',
		icon: 'Dashboard',
		subMenu: null,
	},
};

export const demoPagesMenu = {
	auth: {
		id: 'auth',
		text: 'Auth Pages',
		icon: 'Extension',
	},
	login: {
		id: 'login',
		text: 'Login',
		path: 'auth-pages/login',
		icon: 'Login',
	},
	signUp: {
		id: 'signUp',
		text: 'Sign Up',
		path: 'auth-pages/sign-up',
		icon: 'PersonAdd',
	},
	page404: {
		id: 'Page404',
		text: '404 Page',
		path: 'auth-pages/404',
		icon: 'ReportGmailerrorred',
	},
};

export const pageLayoutTypesPagesMenu = {
	layoutTypes: {
		id: 'layoutTypes',
		text: 'Page Layout Types',
	},
	blank: {
		id: 'blank',
		text: 'Blank',
		path: 'page-layouts/blank',
		icon: 'check_box_outline_blank ',
	},
	pageLayout: {
		id: 'pageLayout',
		text: 'Page Layout',
		path: 'page-layouts',
		icon: 'BackupTable',
		subMenu: {
			headerAndSubheader: {
				id: 'headerAndSubheader',
				text: 'Header & Subheader',
				path: 'page-layouts/header-and-subheader',
				icon: 'ViewAgenda',
			},
			onlyHeader: {
				id: 'onlyHeader',
				text: 'Only Header',
				path: 'page-layouts/only-header',
				icon: 'ViewStream',
			},
			onlySubheader: {
				id: 'onlySubheader',
				text: 'Only Subheader',
				path: 'page-layouts/only-subheader',
				icon: 'ViewStream',
			},
			onlyContent: {
				id: 'onlyContent',
				text: 'Only Content',
				path: 'page-layouts/only-content',
				icon: 'WebAsset',
			},
		},
	},
	asideTypes: {
		id: 'asideTypes',
		text: 'Aside Types',
		path: 'aside-types',
		icon: 'Vertical Split',
		subMenu: {
			defaultAside: {
				id: 'defaultAside',
				text: 'Default Aside',
				path: 'aside-types/default-aside',
				icon: 'ViewQuilt',
			},
			minimizeAside: {
				id: 'minimizeAside',
				text: 'Minimize Aside',
				path: 'aside-types/minimize-aside',
				icon: 'View Compact',
			},
		},
	},
};

export const productsExampleMenu = {
	companyA: { id: 'companyA', text: 'Company A', path: 'grid-pages/products', subMenu: null },
	companyB: { id: 'companyB', text: 'Company B', path: '/', subMenu: null },
	companyC: { id: 'companyC', text: 'Company C', path: '/', subMenu: null },
	companyD: { id: 'companyD', text: 'Company D', path: '/', subMenu: null },
};

// UserMenu diisi dari localStorage (dari response login)
// Format: { [key: string]: { id: string; path: string; text: string; icon: string } }
export const UserMenu: Record<string, { id: string; path: string; text: string; icon: string }> = {};

/**
 * Map known page labels → property name used in routes & sidebar.
 * This bridges API menu IDs (whatever they are) with the expected keys
 * in contentRoutes.tsx (legal_mylist, legal_legaldept, etc.)
 */
const LABEL_TO_KEY: Record<string, string> = {
  'My List': 'legal_mylist',
  'Ajuan': 'legal_mylist',
  'Dept Appv': 'legal_legaldept',
  'Legal Queue': 'legal_legalqueue',
  'Legal Draft': 'legal_legaldraft',
  'Legal Head': 'legal_legalhead',
  'Legal FA': 'legal_legalfa',
  'All Legal': 'legal_legalall',
  'Legal All': 'legal_legalall',
  'Party List': 'legal_partylist',
  'Legal Signed': 'legal_legalsigned',
  'Legal Head Admin': 'legal_legalheadadmin',
  'Legal Due': 'legal_legaldue',
  'User Management': 'settings_user',
  'User': 'settings_user',
  'Role Management': 'settings_role',
  'Role': 'settings_role',
  'Branch': 'settings_branch',
  'Branch Management': 'settings_branch',
  'Department': 'settings_department',
  'Master Data': 'settings_master_data',
  'User Access Review': 'settings_uar',
  'Dashboard': 'dashboard',
  'SLA Dashboard': 'sla_dashboard',
  'SLA Settings': 'settings_sla',
};

function loadUserMenu() {
  try {
    const storedMenu = localStorage.getItem('menu');
    if (!storedMenu) return;
    const menu: Array<{ id: string; text: string; path?: string; icon?: string; children?: any[] }> = JSON.parse(storedMenu);
    const iconMap: Record<string, string> = {
      'Dept Appv': 'Approval',
      'My List': 'DocumentScanner',
      'Ajuan': 'DocumentScanner',
      'Legal Queue': 'Queue',
      'Legal Draft': 'Drafts',
      'Legal Signed': 'Assignment',
      'User Management': 'Person',
      'Role Management': 'Security',
      'User Access Review': 'Security',

      'Department': 'CorporateFare',
    };

    const registerItem = (item: { id: string; text: string; path?: string; icon?: string }) => {
      const menuPath = item.path || `/${item.id}`;
      const entry = {
        id: item.id,
        path: menuPath,
        text: item.text,
        icon: item.icon || iconMap[item.text] || 'ViewCompact',
      };
      // Register by raw API ID
      UserMenu[item.id] = entry;
      // Also register by known label → key mapping so routes can find it
      const knownKey = LABEL_TO_KEY[item.text];
      if (knownKey) {
        UserMenu[knownKey] = entry;
      }
    };

    menu.forEach((item) => {
      if (item.children && item.children.length > 0) {
        // Parent group — register children only
        item.children.forEach((child: any) => registerItem(child));
        return;
      }
      // Leaf menu (standalone)
      registerItem(item);
    });
  } catch {
    // ignore parse errors
  }
}

loadUserMenu();

// Re-export when localStorage changes (e.g. after login)
export function reloadUserMenu() {
  // Clear existing
  Object.keys(UserMenu).forEach((key) => delete UserMenu[key]);
  loadUserMenu();
}
